import { render, staticRenderFns } from "./GeneralView.vue?vue&type=template&id=e78893da&scoped=true&"
import script from "./GeneralView.vue?vue&type=script&lang=js&"
export * from "./GeneralView.vue?vue&type=script&lang=js&"
import style0 from "./GeneralView.vue?vue&type=style&index=0&id=e78893da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e78893da",
  null
  
)

export default component.exports